export default function handleClick(fn, fnArgs) {
  return () => {
    if(!!fn && ('function' === typeof fn)) {
      if(undefined === fnArgs) {
        fn();
      } else {
        fn(fnArgs);
      }
    }
  }
}
